import React from 'react';

/**
 * Shared textarea for forms. Use in both create and update flows.
 */
export default function FormTextarea({
  id,
  label,
  value = '',
  onChange,
  placeholder,
  required,
  disabled,
  error,
  rows = 3,
  className = '',
  ...rest
}) {
  const inputId = id || `textarea-${label?.replace(/\s+/g, '-').toLowerCase() || 'field'}`;
  return (
    <div className={`form-group ${className}`}>
      {label && (
        <label htmlFor={inputId} className="form-label">
          {label}
          {required && <span className="text-danger ms-1">*</span>}
        </label>
      )}
      <textarea
        id={inputId}
        className={`form-control ${error ? 'is-invalid' : ''}`}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        rows={rows}
        {...rest}
      />
      {error && <div className="invalid-feedback d-block">{error}</div>}
    </div>
  );
}
